const CargoFormatter = ({ node, value }) => {
    if ((node && node.group) || !value) {
        return '';
    }
    return value.partType === 'Known' ? value.name : value.value;
};

export default CargoFormatter;
